import actionTypes from '../constants/action-types';
import viewActionTypes from '../../view/constants/action-types';

const globalHTML = (store) => (next) => (action) => {
  switch (action.type) {
    case viewActionTypes.BULK_VIEW_ACTIONS: {
      const actions = action.payload.actions.filter(
        ({ type }) =>
          type === actionTypes.SET_GLOBAL_HTML_AND_AFFECT_HISTORY ||
          type === actionTypes.SET_GLOBAL_HTML
      );

      actions.forEach((globalAction) => {
        store.dispatch(globalAction);
      });

      next(action);
      break;
    }
    default:
      next(action);
  }
};

export default globalHTML;
